// timeline-carousel.js — global include (full feature set)
// Assumes jQuery, Flickity, theme.js (sections helper) already present.
// Keeps 100% of the original functionality: Flickity init, a11y, layout maths,
// hero‑overlay support, Theme‑editor hooks.

window.theme = window.theme || {};

/* =====================================================================
   IndexTimeline – Flickity‑powered horizontal timeline
   ===================================================================== */

theme.IndexTimeline = (function ($) {

  /* ----------------- constructor ------------------------------------ */
  function IndexTimeline (container) {
    var $c          = this.$container = $(container);
    this.sectionId  = $c.data('section-id');
    this.overlay    = $c.data('overlay');          // "true" / "false"

    /* selectors */
    this.slideshowSel = '[data-index-timeline-slideshow]';
    this.imagesSel    = '[data-image-height]';

    this.$slides = $c.find(this.slideshowSel);

    this.init();
    this.layout();

    /* responsive relayout */
    var self = this, wait;
    $(window).on('resize', function () {
      clearTimeout(wait);
      wait = setTimeout(function () { self.layout(); }, 225);
    });
  }

  /* ----------------- prototype -------------------------------------- */
  IndexTimeline.prototype = $.extend({}, IndexTimeline.prototype, {

    /* 1 — Flickity & accessibility */
    init: function () {
      this.$slides.flickity({
        cellAlign: 'left',
        adaptiveHeight: false,
        groupCells: false,
        pageDots: false,
        freeScroll: true,
        contain: true
      });

      /* mark each slide as list‑option for AT */
      this.$slides.find('.timeshow__block').attr('role', 'option');

      /* initial state */
      this.updateA11y();
      this.focusCurrentSlide();

      /* update on every change */
      var self = this;
      this.$slides.on('change.flickity', function () {
        self.updateA11y();
        self.focusCurrentSlide();
      });

      /* give track role + name */
      var $track = this.$slides.find('.flickity-slider'),
          label  = this.$slides.closest('.timeshow__wrapper').attr('aria-label') || 'Timeline carousel';
      $track.attr({ role: 'listbox', 'aria-label': label });

      /* keep arrows as native buttons */
      this.$slides.find('.flickity-button').removeAttr('role aria-hidden tabindex');
    },

    /* 2 — update aria-selected / inert */
      /* 2 — update aria-selected / inert */
    updateA11y: function () {
      var flkty = this.$slides.data('flickity') || {},
          sel   = flkty.selectedIndex || 0;

      this.$slides.find('.timeshow__block').each(function (i, el) {
        var $el = $(el);
        $el.attr('aria-selected', i === sel);
        
        // Remove native inert blocking so all cards remain interactive
        el.removeAttribute('inert');
        if ('inert' in el) {
          el.inert = false;
        }
        $el.removeAttr('aria-hidden');
      });
    },


    /* 3 — move focus into selected slide */
    focusCurrentSlide: function () {
      var flkty = this.$slides.data('flickity');
      if (!flkty) return;
      var slide = flkty.selectedElement;
      if (!slide) return;
      (slide.querySelector('a,button,input,textarea,select,[tabindex="0"]') || slide)
        .focus({ preventScroll: true });
    },

    /* 4 — responsive layout + optional hero overlay */
    layout: function () {
      var $above = this.$container.closest('.shopify-section').prev(),
          hasImg = $above.hasClass('can-overlay');

      /* tallest image */
      var tallest = 0, self = this;
      $(this.imagesSel, this.$container).each(function () {
        tallest = Math.max(tallest, $(this).height());
      });
      this.$container.attr('data-tallest', tallest);

      /* vertically centre images */
      $(this.imagesSel, this.$container).each(function () {
        var h = $(this).height(), pad = (tallest - h) / 2;
        $(this).css({ 'padding-top': pad, 'padding-bottom': pad });
      });

      /* align arrows */
      $('.flickity-button', this.$container).css('margin-top', tallest - 135);

      /* hero overlay variant */
      if (hasImg && this.overlay === 'true') {
        var offset = tallest + $('.timeshow__date').innerHeight();
        this.$container.addClass('timeshow--offset');
        $above.addClass('timeshow--overlayed');

        $('.hero__content__wrapper', $above).css('padding-bottom', offset + 30);
        $('[data-prevent-overflow]', $above).css('min-height', function () {
          return offset + $('[data-prevent-overflow-content]', $above).outerHeight(true);
        });
        $('.scroll_icon_wrap', $above).hide();

        $('.timeshow__wrapper', this.$container)
          .css('transform', 'translateY(-' + offset + 'px)')
          .css('height', function () {
            var tallText = 0;
            $('.timeshow__text', self.$container).each(function () {
              tallText = Math.max(tallText, $(this).height());
            });
            return tallText + 60;
          });

      } else {
        /* reset */
        this.$container.removeClass('timeshow--offset');
        $above.removeClass('timeshow--overlayed');
        $('.timeshow__wrapper', this.$container)
          .css({ transform: 'translateY(0)', height: 'auto' });
        $('.hero__content__wrapper').css('padding-bottom', 0);
        $('.scroll_icon_wrap').show();
      }
    },

    /* 5 — Theme‑editor hooks */
    onReorder:   function () { this.layout(); },

    onBlockSelect: function (evt) {
      var idx = $('.timeshow__block--' + evt.detail.blockId).index();
      this.$slides.flickity('select', idx);
    },

    onUnload: function () {
      this.$slides.flickity('destroy');
    }
  });

  return IndexTimeline;

})(jQuery);

/* =====================================================================
   Register with Sections helper (defined in theme.js)
   ===================================================================== */
if (window.sections && typeof sections.register === 'function') {
  sections.register('index-timeline', theme.IndexTimeline);
}
